// Environment configuration
// Access environment variables using: import { API_URL, DEBUG, LOG_LEVEL } from './config/env';

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:9000';
export const DEBUG = import.meta.env.VITE_DEBUG === 'true';
export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL || 'error';

/** True while the Vite dev server is running (including `vite --mode production`). Used for proxy API base URL, etc. */
export const isDevelopment = import.meta.env.DEV;

export const isProduction = import.meta.env.PROD;

/**
 * True only when Vite was started with `--mode development` (e.g. `npm run dev`).
 * False for `npm run dev:prod` (`vite --mode production`) and production builds — use for UI that should mirror production.
 */
export const isViteDevelopmentMode = import.meta.env.MODE === 'development';

